import { useState } from 'react';
import { RouterProvider } from 'react-router';

import { createQueryClient } from '@/api/query-client';

import { AppProviders } from './app-providers';
import { createAppRouter } from './router';

export function App() {
  const [queryClient] = useState(() => createQueryClient());
  const [router] = useState(createAppRouter);

  return (
    <AppProviders queryClient={queryClient}>
      <RouterProvider router={router} />
    </AppProviders>
  );
}
